import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12.75 4.5h-7.5a.75.75 0 0 0-.75.75V9H3a.751.751 0 0 0-.53 1.28l6 6a.75.75 0 0 0 1.06 0l6-6A.75.75 0 0 0 15 9h-1.5V5.25a.75.75 0 0 0-.75-.75m0 .75v4.5H15l-6 6-6-6h2.25v-4.5zM12.75 1.5h-7.5a.75.75 0 0 0-.75.75V3c0 .414.336.75.75.75h7.5A.75.75 0 0 0 13.5 3v-.75a.75.75 0 0 0-.75-.75m-7.5.75h7.5V3h-7.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }